import type { PhoneValidationInitResponse, PvsApiContract, PvsResponse, StatusResponse } from "@jti/rest-api-types";

import { Rest } from "../../Rest";

/** @deprecated Legacy proxy implementation — superseded by EVO. To be deleted after production verification. */
export class PvsApiLegacy extends Rest implements PvsApiContract {
  readonly name = "PvsApi";
  constructor(
    baseUrl: string,
    protected tenantToken: string
  ) {
    super(baseUrl);
    this.setCommonHeader("X-DES-AK-TENANT-TOKEN", this.tenantToken);
  }

  async verifyOtp(phoneVerificationUuid: string, code: string): Promise<PvsResponse> {
    return this.request(
      `/verify-by-uuid/${phoneVerificationUuid}`,
      {
        body: JSON.stringify({ code }),
        method: "PUT",
      },
      true
    );
  }

  /***
   * @deprecated
   * only used in the dead code at this point in time - might be removed in the future
   */
  async verifyEmailOtp(uuid: string, code: string): Promise<PvsResponse> {
    const response = await this.request<PvsResponse>(
      `/verify-by-uuid/${uuid}`,
      {
        body: JSON.stringify({ code }),
        method: "PUT",
      },
      true
    );
    return response;
  }

  async checkVerificationStatus(uuid: string, hash: string): Promise<StatusResponse> {
    return this.request(`/status/${uuid}/${hash}`, {
      method: "GET",
    });
  }

  async initPhoneValidationByOtp(phone: string): Promise<PhoneValidationInitResponse> {
    return await this.request(
      "/init-phone-validation",
      {
        method: "POST",
        body: JSON.stringify({ phone }),
      },
      true
    );
  }
}
